import { render, staticRenderFns } from "./CreateDisbursement.vue?vue&type=template&id=b8100ad6&"
import script from "./CreateDisbursement.vue?vue&type=script&lang=js&"
export * from "./CreateDisbursement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QBreadcrumbs,QBreadcrumbsEl,QBtnGroup,QSeparator,QForm,QSelect,QField} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QBreadcrumbs,QBreadcrumbsEl,QBtnGroup,QSeparator,QForm,QSelect,QField})
